/**
 * Преобразует СНИЛС в формат XXX-XXX-XXX XX
 *
 * @example
 * transformSnils('9301 9764917') // '930-197-649 17'
 * transformSnils('001-104-607 54') // '001-104-607 54'
 */
export const transformSnils = (data: string) => {
	if (!data) {
		return '';
	}

	const value = data.replace(/\D/g, '');

	if (value.length !== 11) {
		return data;
	}

	return `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6, 9)} ${value.slice(9, 11)}`;
};
